module.exports = __webpack_public_path__ + "static/media/zapper.b459535e.svg";